import React from 'react'

// simple "table" graphic: outer rectangle with a vertical and horizontal
// divider.  It's intended to mirror the style of the other lucide icons
// (stroke only, currentColor) so it can be used interchangeably.
//
// Usage:
//   import { TableIcon } from '@/icons/TableIcon'
//   <TableIcon className="h-4 w-4" />

export const TableIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>table</title>
    <path d="M18.76,6l2,4H3.24l2-4H18.76M20,4H4L1,10v2H3v7H5V16H19v3h2V12h2V10L20,4ZM5,14V12H19v2Z" />
    <rect width="24" height="24" fill="none" />
  </svg>
)
